import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, Calculator } from 'lucide-react';
import WidgetCard from './WidgetCard';
import { useDashboardStore } from '../../../store/useDashboardStore';

export default function QuickValuationWidget() {
  const navigate = useNavigate();
  const { valuations } = useDashboardStore();

  return (
    <WidgetCard
      title="Quick Valuation"
      icon={<Zap className="w-5 h-5" />}
    >
      <div className="text-center space-y-4">
        <div className="bg-blue-50 rounded-full w-14 h-14 flex items-center justify-center mx-auto">
          <Calculator className="w-7 h-7 text-blue-600" />
        </div>
        <div>
          <p className="text-sm text-gray-600 mb-1">
            Get a data-driven valuation in minutes
          </p>
          {valuations.length > 0 && (
            <p className="text-xs text-gray-400">
              {valuations.length} valuation{valuations.length !== 1 ? 's' : ''} completed
            </p>
          )}
        </div>
        <button
          onClick={() => navigate('/valuation')}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 px-4 rounded-lg font-medium transition-colors text-sm"
        >
          Start New Valuation
        </button>
      </div>
    </WidgetCard>
  );
}
